// extracted by mini-css-extract-plugin
module.exports = {"listResults":"styles__listResults___27SgC"};